module.exports = __webpack_public_path__ + "static/media/module-default.a88117d6.png";